const inspectionList = {
  backbtn: "Atrás",
  inspectionList: "Lista de Inspecciones",
  search: "Buscar",
  equipmentTag: "TAG del Equipo",
  customer: "Cliente",
  inspectionDate: "Fecha de Inspección",
  zone: "Zona"
};
export default inspectionList;
